import React from 'react';
import { Button } from 'react-bootstrap';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const FormTableControlColumn = ({ rowId, canDelete, removeItem = () => {}, spanning = 1 }) => {
  const onMouseDown = () => {
    removeItem(rowId);
  };

  const onKeyUp = event => {
    if (event.keyCode === 13 || event.keyCode === 32) {
      removeItem(rowId);
    }
  };

  return (
    <td className="control-column" width="1" rowSpan={spanning}>
      <Button
        disabled={!canDelete}
        variant="danger"
        size="sm"
        className={classNames('remove-button', { hidden: !canDelete })}
        onKeyUp={onKeyUp}
        onMouseDown={onMouseDown}
      >
        <i className="zmdi zmdi-close zmdi-hc-lg" />
      </Button>
    </td>
  );
};

FormTableControlColumn.propTypes = {
  canDelete: PropTypes.bool,
  removeItem: PropTypes.func,
  rowId: PropTypes.number,
  spanning: PropTypes.number,
};

export default FormTableControlColumn;
